import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiGrid, FiCheckCircle, FiLock } from 'react-icons/fi';
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../redux/features/modalSlice";
const truncateWords = (text, limit = 30) => {
  if (!text) return '—';
  const words = text.trim().split(/\s+/);
  if (words.length <= limit) return text;
  return words.slice(0, limit).join(' ') + '...';
};

function ActiveModulesCard({ modules = [], loading = false,subscribedMenuIds = [] }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [featuresModal, setFeaturesModal] = useState(null);
  const handleShowFeatures = (module) => {
    setFeaturesModal(module);
  };
  
  // const handleGetSubscription = (module) => {
  //   dispatch(
  //     openModal({
  //       type: "view-Module-features",
  //       // data: { module },
  //       data: { id: module.id }, 
  //       title: `Subscribe to ${module.name}`,
  //     })
  //   );
  // };
  const handleGetSubscription = (item) => {
    navigate(`/module-features/${item.id}`);
  };
  const isSubscribed = (module) => {
    if (!module || !subscribedMenuIds?.length) return false;
    const moduleName = module.name?.toLowerCase() || "";
    return subscribedMenuIds.some((menuId) => {
      const id = menuId.toLowerCase();
      if (moduleName.includes("lead") && id.includes("lead")) return true;
      if (moduleName.includes("ai calling") && id.includes("lead")) return true;
      if (moduleName.includes("inventory") && id.includes("inventory")) return true;
      if (moduleName.includes("staff") && id.includes("staff")) return true;
      if (moduleName.includes("bulk") && id.includes("bulk")) return true;
      if (moduleName.includes("rcs") && id.includes("rcs")) return true;
      if (moduleName.includes("hrms") && id.includes("hrms")) return true;
      if (moduleName.includes("amc") && id.includes("amc")) return true;
      if (moduleName.includes("chat") && id.includes("chat")) return true;
      return id === moduleName;
    });
  };

  if (loading) {
    return (
      <div className="active-modules-wrap">
        <div className="modules-section-head">
          <div className="dt-header-icon"><FiGrid /></div>
          <h2>Other Services</h2>
        </div>




        <div className="grid">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="stat-card module-stat-card skeleton-card">
              <div className="skeleton-line skeleton-title" />
              <div className="skeleton-line skeleton-desc" />
              <div className="skeleton-line skeleton-value" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!modules.length) return null;

  return (
    <div className="active-modules-wrap">
      <div className="modules-section-head">
        <div className="dt-header-icon"><FiGrid /></div>
        <h2>Other Services</h2>
      </div>
      {/* <div className="grid">
        {modules.map((m) => (   
            
          <div
            key={m.id}
            className={`stat-card module-stat-card clickable ${m.status === 1 ? 'active-module' : 'inactive-module'
              }`}
          >
            <div className="stat-card-top">
              <span className="stat-title">{m.name}</span>
              <span className="stat-icon">
                <span className="module-status-dot" />
              </span>
            </div>
            {m.todo_list?.length > 0 && (
              <ul className="module-todo-list">
                {m.todo_list.map((item, i) => (
                  <li key={i} className="module-todo-item">
                    <span className="mf-check">✓</span>
                    <span className='text-light'>{item}</span>
                  </li>
                ))}
              </ul>
            )}

            <div
              className="module-cta"
              role="button"
              tabIndex={0}
              onClick={() => handleGetSubscription(m)}
              onKeyDown={(e) =>
                e.key === "Enter" && handleGetSubscription(m)
              }
            >
              View Features →
            </div>
          </div>
        ))}
      </div> */}


    <div className="grid">
  {modules.map((m) => {
    const subscribed = isSubscribed(m);

    return (
      <div
        key={m.id}
        className={`stat-card module-stat-card ${
          subscribed ? 'active-module' : 'inactive-module clickable'
        }`}
      >
        <div className="stat-card-top">
          <span className="stat-title">{m.name}</span>
          <span className="stat-icon">
            <span
              className={`module-status-badge ${
                subscribed ? 'badge-subscribed' : 'badge-available'
              }`}
            >
              {subscribed ? (
                <>
                  <FiCheckCircle size={11} /> Subscribed
                </>
              ) : (
                <>
                  <FiLock size={11} /> Available
                </>
              )}
            </span>
          </span>
        </div>

        {m.todo_list?.length > 0 && (
          <ul className="module-todo-list">
            {m.todo_list.map((item, i) => (
              <li key={i} className="module-todo-item">
                <span className="mf-check">✓</span>
                <span className='text-light'>{item}</span>
              </li>
            ))}
          </ul>
        )}

        {/* ✅ CTA — sirf non-subscribed clickable */}
        {subscribed ? (
          <div className="module-cta module-cta-disabled">
            ✓ Active
          </div>
        ) : (
          <div
            className="module-cta"
            role="button"
            tabIndex={0}
            onClick={() => handleGetSubscription(m)}
            onKeyDown={(e) =>
              e.key === "Enter" && handleGetSubscription(m)
            }
          >
            View Features →
          </div>
        )}
      </div>
    );
  })}
</div>

    </div>

   

  );
}

export default ActiveModulesCard;